import { render, staticRenderFns } from "./ADLightbox.vue?vue&type=template&id=1067637c&"
import script from "./ADLightbox.vue?vue&type=script&lang=js&"
export * from "./ADLightbox.vue?vue&type=script&lang=js&"
import style0 from "./ADLightbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports